import { render, staticRenderFns } from "./CrmProjectDepartmentPopupWrappable.vue?vue&type=template&id=c248730c&scoped=true&lang=pug&"
import script from "./CrmProjectDepartmentPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./CrmProjectDepartmentPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./CrmProjectDepartmentPopupWrappable.vue?vue&type=style&index=0&id=c248730c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c248730c",
  null
  
)

export default component.exports